module.exports = __webpack_public_path__ + "img/logo.5c21966b.svg";